<template>
  <div class="dysphotopsia-breakdown" v-if="dataLoaded">

    <div class="top">
      <chart-item class='chart-summary' :data="mainReports" :isLink="false" :colorOverride="'#2E96D6'" :percentColorOverride="'#2E96D6'" />
      <chart-item-filter v-if="showIolFilter(0)"
        :iols="iols"
        class='chart-summary'
        v-model="iolFilters[0]"
        @input="iolFilterChanged(0)"
      />
      <chart-item v-if="subReports[0].report"
        class='chart-summary'
        :isLink="false"
        :canClose="true"
        :colorOverride="'#DF5B96'"
        :percentColorOverride="'#2E96D6'"
        :data="subReports[0].report"
        @close="iolFilterClosed(subReports[0].report[0].name)"
      />
      <chart-item-filter v-if="showIolFilter(1)"
        :iols="iols"
        class='chart-summary'
        v-model="iolFilters[1]"
        @input="iolFilterChanged(1)"
      />
      <chart-item v-if="subReports[1].report"
        class='chart-summary'
        :isLink="false"
        :canClose="true"
        :colorOverride="'#F2C94C'"
        :percentColorOverride="'#2E96D6'"
        :data="subReports[1].report"
        @close="iolFilterClosed(subReports[1].report[0].name)"
      />
      <chart-item-filter v-if="showIolFilter(2)"
        :iols="iols"
        class='chart-summary'
        v-model="iolFilters[2]"
        @input="iolFilterChanged(2)"
      />
      <chart-item v-if="subReports[2].report"
        class='chart-summary'
        :isLink="false"
        :canClose="true"
        :colorOverride="'#F09639'"
        :percentColorOverride="'#2E96D6'"
        :data="subReports[2].report"
        @close="iolFilterClosed(subReports[2].report[0].name)"
      />
    </div>

    <div class="mid">
      <div class="chart-actions">
        <div class="chart-dropdown">
          <rp-dropdown
            v-model="currentChart"
            :data-model="chartTypes"
            disable-search
            object-label="name"
            placeholder="Summary"
            tempIdentifier="Type"
            iconText="View Scores By:"
          />
        </div>
      </div>
      <Bar v-if="this.currentChart && this.currentChart.value=='BarChart'"
        id="bar-satisfaction"
        :chart-data="barChartData"
        :chart-options="barChartOptions"
        :height="300"
      />
    </div>

    <div class="bottom" v-if="this.currentChart && this.currentChart.value=='Summary'">
      <chart-item-quad :data="mainReports" :reports="mainReports" :percentColorOverride="'#2E96D6'" />
      <div class="chart-item-spacer" v-if="!subReports[0].report" />
      <chart-item-quad v-if="subReports[0].report" :data="subReports[0].report" :reports="subReports[0].report" :percentColorOverride="'#DF5B96'" />
      <div class="chart-item-spacer" v-if="!subReports[1].report" />
      <chart-item-quad v-if="subReports[1].report" :data="subReports[1].report" :reports="subReports[1].report" :percentColorOverride="'#F2C94C'" />
      <div class="chart-item-spacer" v-if="!subReports[2].report" />
      <chart-item-quad v-if="subReports[2].report" :data="subReports[2].report" :reports="subReports[2].report" :percentColorOverride="'#F09639'" />
    </div>

  </div>
</template>

<script>
  import ChartItem from '../ChartItem_v2'
  import ChartItemQuad from '../ChartItemQuad_v2'
  import ChartItemFilter from '../ChartItemFilter_v2'
  import SelectField from 'raypro_ui/src/components/ui/inputs/StyledSelect'
  import RpSprite from 'raypro_ui/src/components/ui/Sprite'
  import Dropdown from 'raypro_ui/src/components/ui/inputs/dropdown/Dropdown'
  import breakdown from '../../../../mixins/breakdown'
  // Chart.js
  import {Bar, Line as LineChartGenerator} from 'vue-chartjs/legacy'
  import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement} from 'chart.js'
  ChartJS.register(Title, Tooltip, Legend, BarElement, LineElement, CategoryScale, LinearScale, PointElement)

  export default {
    mixins: [breakdown],

    components: {
      Bar,
      LineChartGenerator,
      ChartItem,
      ChartItemQuad,
      ChartItemFilter,
      RpSprite, 
      SelectField, 
      'rp-dropdown': Dropdown,
    },

    data() {
      return {
        reports: [],
        globalReport: {},
        subReports: [
          {report: null, filter: '', color: '#DF5B96'},
          {report: null, filter: '', color: '#F2C94C'},
          {report: null, filter: '', color: '#F09639'},
        ],
        chartTypes: [
          {name: 'Summary', value: 'Summary'},
          {name: 'Distribution', value: 'BarChart'},
        ],
        currentChart: {name: 'Summary', value: 'Summary'},
        barChartData: {
          labels: ['3 Months - Day', '1 Year - Day', '3 Months - Night', '1 Year - Night'],
          datasets: [
            {label: 'Visual disturbances', borderColor:'#2E96D6', backgroundColor: '#2E96D6', data: []}
          ]
        },
        customLabels: [],
        barChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 25,
            }
          },
          plugins: {
            datalabels: {
              align: 'top',
              anchor: 'end',
              formatter: (_value, context) => {
                const { datasetIndex, dataIndex } = context
                return this.customLabels[datasetIndex][dataIndex]
              },
            },
            tooltip: {
              callbacks: {
                title: (context) => {
                  return `${context[0].dataset.label}`
                },
                label: (context) => {
                  return `Score: ${context.formattedValue}%`
                },
                afterBody: (context) => {
                  const { datasetIndex, dataIndex } = context[0]
                  return `Responses: ${this.customLabels[datasetIndex][dataIndex]}`
                },
              }
            },
            legend: {
              display: true,
              position: 'bottom'
            }
          },
          scales: {
            y: {
              title: {
                display: true,
                text: 'Average Score %'
              },
              ticks: {
                stepSize: 10,
                callback: (label) => {
                  return `${label}%`
                }
              },
            },
          },
        },
      }
    },

    computed: {
      mainReports() {
        if (this.filterParams.includes('iol=') === false) {
          return this.reports
        } else {
          return [
            this.truncateReportToTimeSpan(this.globalReport[0]),
            this.truncateReportToTimeSpan(this.globalReport[1]),
            this.truncateReportToTimeSpan(this.globalReport[2]),
            this.truncateReportToTimeSpan(this.globalReport[3])
          ]
        }
      },
    },

    methods: {
      async getReports() {
        let report = await this.getAllReportsPromise(this.filterParams)
        this.reports = this.filterReportDatas(report)
        this.globalReport = this.filterReportDatas({data: this.getGlobalReport('Dysphotopsia', 'dysphotopsia')})

        await this.getSubReports()
        this.processBarData()
        this.dataLoaded = true
      },

      processBarData() {
        var colors = ['#2E96D6']
        var threeMonthDay = [this.mainReports[0]]
        var threeMonthNight = [this.mainReports[1]]
        var oneYearDay = [this.mainReports[2]]
        var oneYearNight = [this.mainReports[3]]
        for (var i = 0; i < 3; i++) {
          if (this.subReports[i].report) {
            colors.push(this.subReports[i].color)
            threeMonthDay.push(this.subReports[i].report[0])
            threeMonthNight.push(this.subReports[i].report[1])
            oneYearDay.push(this.subReports[i].report[2])
            oneYearNight.push(this.subReports[i].report[3])
          }
        }

        this.barChartData.datasets = this.generateBarData([threeMonthDay, oneYearDay, threeMonthNight, oneYearNight], colors)
      },

      generateBarData(reports, colors) {
        var data = []
        var groups = reports[0].map(x => x.name)
        groups[0] = groups.length > 1 ? 'Global Benchmark' : 'Visual disturbances'
        this.customLabels = new Array(groups.length)

        for (var i = 0; i < groups.length; i++) {
          this.customLabels[i] = new Array(reports.length)
          data.push({
            label: groups[i],
            backgroundColor: colors[i],
            data: this.getGroupData(groups[i], groups, reports)
          })
        }

        return data
      },

      getGroupData(group, groups, reports) {
        var groupData = []
        var groupIndex = groups.indexOf(group)
        for (var i = 0; i < reports.length; i++) {
          this.customLabels[groupIndex][i] = this.getResponseCount(reports[i][groupIndex].report_datas.data)
          groupData.push(this.getPercentage(reports[i][groupIndex].report_datas.data))
        }

        return groupData
      },

      getResponseCount(data) {
        if (data.error) {
          return 0
        }

        let responses = []
        Object.keys(data).forEach((key) => {
          responses.push(data[key])
        })

        responses = responses.reduce((a, b) => a + b, 0)
        return responses
      },

      getPercentage(data) {
        let scores = []
        let responses = []

        Object.keys(data).forEach((key) => {
          scores.push(key * data[key])
          responses.push(data[key])
        })

        scores = scores.reduce((a, b) => a + b, 0)
        responses = responses.reduce((a, b) => a + b, 0)
        const value = parseInt(scores / responses * 10)
        return isNaN(value) ? 0 : value
      },

      generateBarLabels(reports) {
        return [
          '3 Months - Day',
          '1 Year - Day',
          '3 Months - Night',
          '1 Year - Night',
        ]
      },

      async getSubReports() {
        const models = this.getModelNamesFromFilterParams()
        for (const model of models) {
          let index = 0
          const filterItem = this.iolFilters.find(x => x && x.model === model)
          if (filterItem) {
            index = this.iolFilters.indexOf(filterItem)
          }

          const filterParams = this.getSubReportFilterParams(models.indexOf(model))
          let report = await this.getAllReportsPromise(filterParams)
          report = this.filterReportDatas(report)
          report[0].name = model
          this.subReports[index].report = report
          this.subReports[index].filter = filterParams
        }
      },

      updateSubReports() {
        this.subReports.forEach((subReport) => {
          if (subReport.report && !this.iolFilters.find((x) => x && x.model === subReport.report[0].name)) {
            subReport.filter = ''
            subReport.report = null
          }
        })
      },

      downloadReport(index) {
        this.getExportReportPromise(this.reports[index].id, this.reports[index].slug).then((res) => {
          this.downloadResult(res)
        })
      },

      filterReportDatas(data) {
        let filtered = data.data.filter((entry) => {
          if (entry.slug === 'dysphotopsia') {
            if (entry.name === 'Dysphotopsia') {
              entry.name = 'Visual disturbances'
            }
            if (entry.category === 'during the day') {
              entry.order = 2
              entry.category = 'Day|1 Year'
            } else if (entry.category === 'during the day at 3 months') {
              entry.order = 0
              entry.category = 'Day|3 Months'
            } else if (entry.category === 'during the night') {
              entry.order = 3
              entry.category = 'Night|1 Year'
            } else if (entry.category === 'during the night at 3 months') {
              entry.order = 1
              entry.category = 'Night|3 Months'
            }
            return entry
          }
          return false
        })

        filtered.sort((a, b) => {
          if (a.order < b.order) { return -1 } 
          else if (a.order > b.order) { return 1 }
          return 0
        })

        return filtered
      },

      setDownloadOptions() {
        this.$emit('setDownloadOptions', ['Day (3 months)', 'Night (3 months)', 'Day (1 year)', 'Night (1 year)'])
      },

      iolFilterChanged(index) {
        if (this.iolFilters[index]) {
          if (this.iolFilters[index] && !this.subReports.find(x => x.report && x.report[0].name === this.iolFilters[index].model)) {
            this.$emit('addIolFilter', this.iolFilters[index].id)
          } else {
            this.iolFilters[index] = null
          }
        }
      },

      iolFilterClosed(model) {
        const iol = this.iolFilters.find((x) => x && x.model === model)
        this.subReports[this.iolFilters.indexOf(iol)].filter = ''
        this.subReports[this.iolFilters.indexOf(iol)].report = null
        this.iolFilters[this.iolFilters.indexOf(iol)] = null
        this.$emit('removeIolFilter', iol.id)
      },
    }
  }
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .dysphotopsia-breakdown
    display: flex
    flex-direction: column
    width: 100%
    min-width: 768px    
    padding: 10px
    margin-right: -30px
    box-shadow: $color-shadow
    background-color: transparent

    .bottom
      display: flex
      flex-direction: row
      gap: 40px

      .quad-chart
        display: flex
        flex-wrap: wrap
        background: transparent

        .quad-item
          width: 50%
          height: 50%
          border-radius: 20px
          background: $color-panel-bg

      .chart-item-spacer
        width: calc(25% - 30px)

    .mid
      width: 100%
      border-radius: 20px
      margin-bottom: 15px
      background-color: $color-panel-bg

      .chart-actions
        color: $color-text
        width: 189px
        height: 64px
        margin-left: auto
        margin-right: 18px
        margin-bottom: -32px

        @include media($media-small)
          align-items: center

    .top
      display: flex
      flex-direction: column
      justify-content: flex-start
      width: 100%
      gap: 40px
      
      @include media($media-small)
        flex-direction: row

      .chart-summary
        margin-right: 0px

</style>



// WEBPACK FOOTER //
// src/components/pages/Dashboard/Breakdowns/Dysphotopsia_v2.vue